import type { JSX } from 'react'
import { Link } from 'react-router'

export default function Page403(): JSX.Element {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-4 text-center">
      <h1 className="text-4xl font-bold text-gray-800">403</h1>
      <h2 className="text-xl font-semibold text-gray-700">Access Denied</h2>
      <p className="text-sm text-gray-500">
        You don&apos;t have permission to view this page.
      </p>
      <Link to="/" className="text-sm text-blue-600 hover:underline">
        Back to home
      </Link>
    </div>
  )
}
